import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-ep-input-indicators',
  templateUrl: './ep-input-indicators.component.html',
  styleUrls: ['./ep-input-indicators.component.scss'],
})
export class EpInputIndicatorsComponent {
  @Input() isValid: boolean | null = null;
  @Input() isLoading: boolean | null = null;
  @Input() showNewStatus = false;
  @Input() value?: string;
  @Input() title: string = '';
  @Input() info: string = '';
  @Input() statusText: string = '';
  @Input() inputPlaceholder: string = '';
  @Input() hasClientSideError: boolean | null = null;
  @Input() clientErrorStatus: number | null = null;
  @Input() clientErrorText: string | null = null;
  @Output() submitInput = new EventEmitter<string>();
  @Output() ngModelChange = new EventEmitter<string>();

  public setValue(value: string): void {
    if (value !== this.value) {
      this.value = value;
      this.onChange(value);
    }
  }

  public formInputSubmit(): void {
    this.submitInput.emit(this.value);
  }

  private onChange(_: string): void {
    this.ngModelChange.emit(_);
  }
}
